import * as ReactRedux from 'react-redux';
import CreateEventModalComponent from './create.event.modal.component';
import { AppState } from '../app/app.types';
import { createCalendarEvent, updateCalendarEvent, deleteCalendarEvent } from './dashboard.actions';
import { Event } from '../calendar/calendar.event.types';

type OwnProps = {
  readonly modalOpen: boolean
  readonly editMode: boolean
  readonly selectedEvent?: Event
  readonly slotInfo?: any
  readonly loadingMembers: boolean
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    createCalendarEvent: (
      colorValue: string,
      title: string,
      startDate: number,
      endDate: number,
      note: string,
      memberId?: number,
      staffId?: number
    ) => dispatch(createCalendarEvent(colorValue, title, startDate, endDate, note, memberId, staffId)),
    updateCalendarEvent: (
      id: number,
      colorValue: string,
      title: string,
      startDate: number,
      endDate: number,
      note: string,
      memberId?: number,
      staffId?: number
    ) => dispatch(updateCalendarEvent(id, colorValue, title, startDate, endDate, note, memberId, staffId)),
    deleteCalendarEvent: (id: number) => dispatch(deleteCalendarEvent(id))
  };
};

const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    dashboardState: state.dashboardState,
    idleState: state.idleState,
    membersState: state.membersState,
    businessState: state.businessState
  };
};

const CreateEventModal: React.ComponentClass<OwnProps> =
  ReactRedux.connect(mapStateToProps, mapDispatchToProps)(CreateEventModalComponent);

export default CreateEventModal;



// WEBPACK FOOTER //
// ./src/dashboard/create.event.modal.tsx